import { Component, EventEmitter, Output } from '@angular/core';

/**
 * Shell topbar (ws:shell / ws:search). Owns the top row layout and hosts its pieces:
 *  - app-topbar-search: the global search trigger + panel
 *  - app-tool-bar: account switcher + profile menu (unchanged logic, restyled later)
 * Reference: design/prototype/assets/shell.js (#pa-topbar).
 */
@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.css'],
  standalone: false
})
export class TopbarComponent {
  @Output() logoClicked = new EventEmitter<void>();
}
